<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
  }
/* reset */
html,body,h1,h2,h3,h4,h5,h6,div,dl,dt,dd,ul,ol,li,p,blockquote,pre,hr,figure,table,caption,th,td,form,fieldset,legend,input,button,textarea,menu{margin:0;padding:0;}
header,footer,section,article,aside,nav,hgroup,address,figure,figcaption,menu,details{display:block;}
table{border-collapse:collapse;border-spacing:0;}
caption,th{text-align:left;font-weight:normal;}
html,body,fieldset,img,iframe,abbr{border:0;}
i,cite,em,var,address,dfn{font-style:normal;}
[hidefocus],summary{outline:0;}
li{list-style:none;}
h1,h2,h3,h4,h5,h6,small{font-size:100%;}
sup,sub{font-size:83%;}
pre,code,kbd,samp{font-family:inherit;}
q:before,q:after{content:none;}
textarea{overflow:auto;resize:none;}
label,summary{cursor:default;}
a,button{cursor:pointer;}
h1,h2,h3,h4,h5,h6,em,strong,b{font-weight:bold;}
del,ins,u,s,a,a:hover{text-decoration:none;}
body,textarea,input,button,select,keygen,legend{  
  /*  字体  */
  font-family: -apple-system, BlinkMacSystemFont, 'Microsoft YaHei', sans-serif;
  
  /*  字号 */
  font-size: 16px;
  
  /*  字体颜色  */
  color: #333;
  
  /* 行距 */
  line-height: 1.75;
  }
body{background:#fff;}
a,a:hover{color:#333;}

  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .el-button--primary{
    background: #198bfd;
  }
.clear:after{content:'';display:block;clear:both;height:0;overflow:hidden;visibility:hidden;}
.clear{zoom:1;}

  .errMessage.el-message-box{
    width: 270px;
  }
  .errMessage .el-icon-error{
    font-size: 20px!important;
    padding-top: 5px;
  }
  .errMessage .el-message-box__btns .el-button{
    margin-top: 10px;
    padding: 9px 27px;
  }
  .problemCode .el-input__inner{
  height: 50px;
}
.problemBox .el-dialog__title{
    font-size: 30px;
    font-weight: bold;
    line-height: 50px;
    color: #eb5468;
}
.problemBox .el-dialog__body{
  padding-top: 0;
}
.page_l{
    width: 480px;
    height: 100vh;
    position: fixed;
}
.page_r{
    margin-left: 480px;
    position: relative;
    height: 100vh;
}
.page_r .main{
    position: absolute;
    width: 100%;
    min-width: 480px;
    height: 100vh;
}
@media screen and (max-width:1140px) {
  .page_l {
    width: 240px;
  }
  .page_r{
        margin-left: 240px;
    }
}
@media screen and (max-width:960px) {
    .page_l{
        display: none;
    }
    .page_r{
        margin-left: 0;
    }
}

/* 找回密码上成功状态上边的小圆点 */
.el-step__line{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue